import Filters from '@/components/DynamicComponents/Projects/Filters'
import ProjectTable from '@/components/DynamicComponents/Projects/ProjectTable'
import { dateComparator } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import { highlightArchiveRow } from '@/services/grid'

export default {
  components: {
    ProjectTable,
    Filters,
  },
  data() {
    return {
      columns: [
        {
          headerName: 'Client ID',
          field: 'clientId',
          width: 80,
          cellStyle: params => highlightArchiveRow(params, 'left'),
          headerTooltip: 'Client ID',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'dashboardProject' },
        },
        {
          headerName: 'Project #',
          field: 'projectNumber',
          width: 80,
          cellStyle: params => highlightArchiveRow(params, 'left'),
          headerTooltip: 'Project #',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'dashboardProject' },
        },
        {
          headerName: 'Project Name',
          field: 'projectName',
          width: 120,
          cellStyle: params => highlightArchiveRow(params, 'left'),
          headerTooltip: 'Project Name',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'dashboardProject' },
        },
        {
          headerName: 'Project Staff Engineer',
          field: 'projectStaffEngineer',
          width: 100,
          cellStyle: params => highlightArchiveRow(params, 'left'),
          headerTooltip: 'Project Staff Engineer',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'dashboardProject' },
        },
        {
          headerName: 'Project Manager',
          field: 'projectManager',
          width: 100,
          cellStyle: params => highlightArchiveRow(params, 'left'),
          headerTooltip: 'Project Manager',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'dashboardProject' },
        },
        {
          headerName: 'Project Reviewer',
          field: 'projectReviewer',
          width: 100,
          cellStyle: params => highlightArchiveRow(params, 'left'),
          headerTooltip: 'Project Reviewer',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'dashboardProject' },
        },
        {
          headerName: 'City',
          field: 'city',
          width: 80,
          cellStyle: params => highlightArchiveRow(params, 'left'),
          headerTooltip: 'City',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'dashboardProject' },
        },
        {
          headerName: 'State',
          field: 'state',
          width: 80,
          cellStyle: params => highlightArchiveRow(params, 'left'),
          headerTooltip: 'State',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'dashboardProject' },
        },
        {
          headerName: 'Entity Name',
          field: 'entityName',
          width: 80,
          cellStyle: params => highlightArchiveRow(params, 'left'),
          headerTooltip: 'Entity Name',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'dashboardProject' },
        },
        {
          headerName: 'SF Percent Complete',
          field: 'percentComplete',
          width: 80,
          cellStyle: params => highlightArchiveRow(params, 'left'),
          headerTooltip: 'SF Percent Complete',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'dashboardProject',
            name: 'percentComplete',
          },
        },
        {
          headerName: 'Time Spent',
          field: 'timeSpent',
          width: 80,
          cellStyle: params => highlightArchiveRow(params, 'left'),
          headerTooltip: 'Total Time Spent In Project',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            type: 'dashboardProject',
            name: 'timeSpent',
          },
        },
        {
          headerName: 'Created Date',
          field: 'createdDate',
          width: 120,
          cellStyle: params => highlightArchiveRow(params, 'left'),
          comparator: dateComparator,
          headerTooltip: 'Created Date',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: { type: 'dashboardProject', name: 'createdDate' },
        },
        {
          headerName: 'Updated Date',
          field: 'updatedDate',
          width: 120,
          cellStyle: params => highlightArchiveRow(params, 'left'),
          comparator: dateComparator,
          headerTooltip: 'Updated Date',
          cellRenderer: 'toolTipRenderer',
          sort: 'desc',
          cellRendererParams: { type: 'dashboardProject', name: 'updatedDate' },
        },
        {
          headerName: 'Action',
          field: 'action',
          headerClass: 'header-center',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          floatingFilter: false,
          width: 120,
          cellRendererParams: { type: 'Project Dashboard' },
          toolPanelClass: 'hide-column',
          resizable: false,
          suppressSizeToFit: true,
          pinned: 'right',
        },
      ],
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 4px !important',
      },
      url: projectAPIs.project.list,
      loading: false,
      title: '',
    }
  },
  methods: {
    showLoader(flag, title) {
      this.loading = flag
      this.title = title
    },
  },
}
